import React from "react";
import LineUpCard from "./LineUpCard";
import dayjs from "dayjs";
import 'dayjs/locale/id';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useTitleCase } from "@/hooks";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

dayjs.extend(localizedFormat);
dayjs.locale("id");

export default function MainInfo(props) {
    // console.log(props);
    const { tgl_mulai, tgl_selesai, jam_mulai, jam_selesai, deskripsi, benefit, special_note, kota, alamat, jenis, tema, attendance_pass, rundown_acara } = props.item;
    let event_date = dayjs(tgl_mulai).format("LL");
    if (tgl_mulai !== tgl_selesai)
        event_date = `${dayjs(tgl_mulai).format("LL")} - ${dayjs(tgl_selesai).format("LL")}`;

    const passTypeDesc = {
        one_time: {
            label: "One Time",
            desc: "Setelah keluar dari venue, peserta tidak diperbolehkan masuk kembali ke dalam venue",
        },
        multi_time: {
            label: "Multi Time",
            desc: "Peserta diperbolehkan keluar masuk venue tanpa batasan",
        },
        custom: {
            label: "Custom",
            desc: `Peserta diperbolehkan keluar-masuk venue sebanyak ${attendance_pass?.pass_limit} kali`
        }
    };

    const Label = ({ id, children, title }) => (
        <OverlayTrigger placement="bottom"
            overlay={<Tooltip id={id}>{title}</Tooltip>}
        >
            <div className="event-category-card">
                <span>{useTitleCase(children.length > 10 ? `${children.substring(0, 10)}...` : children)}</span>
            </div>
        </OverlayTrigger>
    );
        console.log(props.contactOrganizer);
    return (
        <section id="main-info">
            <h4 className="ml-4 mb-0">Deskripsi</h4>
            <hr />
            <div className="d-flex justify-content-between align-items-center info-slide">
                <div className="info-card" style={{ width: '410px' }}>
                    <img
                        src="/images/icon/date.svg"
                        alt="date"
                        className="mb-sm-3 mb-2"
                    />
                    <span className="text-muted">Tanggal</span>
                    <h5 className="mt-2">{event_date}</h5>
                </div>
                <div className="info-card" style={{ width: '410px' }}>
                    <img
                        src="/images/icon/clock.svg"
                        alt="clock"
                        className="mb-sm-3 mb-2"
                    />
                    <span className="text-muted">Waktu</span>
                    <h5 className="mt-2">
                        {`${jam_mulai.replace(
                            /(\d{1,2}:\d{2}):\d{2}/,
                            "$1"
                        )} - ${jam_selesai.replace(
                            /(\d{1,2}:\d{2}):\d{2}/,
                            "$1"
                        )}`}{" "}
                        WIB
                    </h5>
                </div>
                <div className="info-card" style={{ width: '410px' }}>
                    <img
                        src="/images/icon/capacity.svg"
                        alt="capacity"
                        className="mb-sm-3 mb-2"
                    />
                    <span className="text-muted">Kapasitas</span>
                    <h5 className="mt-2">{props.kapasitas} peserta</h5>
                </div>
            </div>
            <div className="about-event">
                <h5 className="mb-0">Tentang Event</h5>
                <div className="title-list"></div>
                {deskripsi ? <p className="mb-0" dangerouslySetInnerHTML={{
                    __html: deskripsi,
                }}></p> : '-'}

                <div className="row justify-content-between">
                    {(benefit !== null) && (
                        <div className="col-lg-6">
                            <h5 className="mb-0">Benefit</h5>
                            <div className="title-list"></div>
                            <div dangerouslySetInnerHTML={{
                                __html: benefit,
                            }}></div>
                        </div>
                    )}
                    {(special_note !== null) && (
                        <div className="col-lg-6">
                            <h5 className="mb-0">Special Note</h5>
                            <div className="title-list"></div>
                            <div dangerouslySetInnerHTML={{
                                __html: special_note,
                            }}></div>
                        </div>
                    )}
                    {(kota !== 'Online') && (
                        <div className="col-lg-6">
                            <h5 className="mb-0">Lokasi Event</h5>
                            <div className="title-list"></div>
                            <p className="mb-0">
                                {alamat ?? '-'}
                            </p>
                        </div>
                    )}
                    {
                        props.contactOrganizer!=null && props.contactOrganizer?.length != 0?
                        <div className="col-lg-6 contact-person">
                            <h5 className="mb-0">Contact Person</h5>
                            <div className="title-list"></div>
                            <div className="row align-items-sm-center align-items-start justify-content-start">
                            {props.contactOrganizer.map((contactItem, i) => (
                                contactItem.number_contact||contactItem.name_contact?<ContactItem contact={contactItem} key={i}/>:""
                            ))}
                            </div>
                        </div>:""
                    }
                    <div className="col-lg-6">
                        <h5 className="mb-0">Jenis Event</h5>
                        <div className="title-list"></div>
                        <div className="d-flex event-category">
                            <div className="event-category-card">
                                {useTitleCase(jenis)}
                            </div>
                            {tema && (<div className="event-category-card">
                                {useTitleCase(tema)}
                            </div>)}
                        </div>
                    </div>
                    {rundown_acara && (
                            <div className="col-lg-6">
                                <h5 className="mb-0">Rundown Acara</h5>
                                <div className="title-list"></div>
                                <div className='d-flex align-items-center pt-2'>
                                    <i className="far fa-file-alt text-main-red me-3"></i>
                                    <a className="text-decoration-none text-dark" href={`/download-file-rundown/${rundown_acara}`}>{rundown_acara }</a>
                                </div>
                            </div>
                        )
                    }

                    {attendance_pass?.pass_type && (
                        <div className="col-lg-6">
                            <h5 className="mb-0">Sistem Keluar Masuk Peserta</h5>
                            <div className="title-list"></div>
                            <div className="d-flex event-category">
                                <Label id="pass-type" title={passTypeDesc[attendance_pass.pass_type].desc}>
                                    {passTypeDesc[attendance_pass.pass_type].label}
                                </Label>
                            </div>
                        </div>
                    )}

                </div>

                {props.lineup.length != 0 && (
                    <div className="row justify-content-between">
                        <div className="col-12">
                            <h5 className="mb-0">Line-up</h5>
                            <div className="title-list"></div>
                            <div className="d-flex me-3 lineup-slide">
                                <LineUpCard lineup={props.lineup} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}

const ContactItem = ({contact}) => {
    return (
        <div className="col-lg-6">
            <div className="d-flex align-items-center">
                <img
                    src={
                        contact.type === 'instagram' && `/images/icon/instagram.svg` ||
                        contact.type === 'kontak_hp' && `/images/icon/phone.svg` ||
                        contact.type === 'kontak_wa' && `/images/icon/whatsapp.svg` ||
                        contact.type === 'email' && `/images/icon/mail.svg`
                    }
                    alt="phone"
                />
                <div className="ml-3 ms-3">
                    <span className="text-muted">
                    {contact.type === 'kontak_hp' && 'Kontak Handphone'}
                    {contact.type === 'kontak_wa' && 'Kontak Whatsapp'}
                    {contact.type === 'instagram' && 'Instagram'}
                    {contact.type === 'email' && 'Email'}
                    </span>

                    <h6 className="mt-1">
                        <a href={
                            contact.type === 'kontak_hp' && `tel:${contact.number_contact}` ||
                            contact.type === 'kontak_wa' && `https://api.whatsapp.com/send?phone=${contact.number_contact}` ||
                            (contact.type === 'instagram' && contact.name_contact != null) && `https://instagram.com/${contact.name_contact.replace('@', '')}`
                        } target="_blank" className="text-decoration-none text-dark">
                        {contact.number_contact ? `${contact.number_contact} `+(contact.name_contact?`(${contact.name_contact})`:"") : `${contact.name_contact}`}
                        </a>
                    </h6>
                </div>
            </div>
        </div>
    )
}
